export const getCompanies = ({
  token,
  page,
  sortBy,
  sortDirection,
  search,
  fetchAll,
}) => {
  const params = new URLSearchParams({
    page,
    sortBy,
    sortDirection,
    search,
    fetchAll,
  }).toString()
  return fetch(`${process.env.GATSBY_FUNCTION_PATH}/get-companies?${params}`, {
    method: 'GET',
    headers: {
      token,
    },
  })
}

export const createCompany = ({token, name}) => {
  return fetch(`${process.env.GATSBY_FUNCTION_PATH}/create-company`, {
    method: 'POST',
    body: JSON.stringify({name}),
    headers: {
      token,
    },
  })
}

export const deleteCompany = ({companyId, token}) => {
  return fetch(
    `${process.env.GATSBY_FUNCTION_PATH}/delete-company?companyId=${companyId}`,
    {
      method: 'DELETE',
      headers: {
        token,
      },
    },
  )
}

export const getCompany = ({token, id}) =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/get-company?companyId=${id}`, {
    method: 'GET',
    headers: {
      token,
    },
  })
